
import TablePop from "@/components/table-pop.vue";
import Loading from "../../components/loading.vue";
import { Component, Vue } from "vue-property-decorator";
import ExamList from "@/lib/model/exam/exam";
import { ExamGetAllForm } from "@/lib/form/exam/ExamListForm";
import Auth from "@/lib/common/auth";
import {
  BatchSendParams,
  LogNew,
  LogSearchForm,
  SendParam
} from "@/lib/model/message/msg-new";

@Component({
  components: {
    TablePop,
    Loading
  }
})
export default class MessageNotice extends Vue {
  searchForm: LogSearchForm = new LogSearchForm();
  examAll: { id: number; name: string }[] = [];
  canRefresh = true;
  tableLoading = false;
  selectedRowList: any[] = [];
  total = 0;
  selectAll = false;
  sendParam = new SendParam();
  batchSendParam: BatchSendParams = {
    companyId: Auth.companyId,
    logIdList: [],
    sendMobile: true,
    sendEmail: false
  };
  showSendConfirmDialog = false;
  dialogTitle = "";
  batchLoading = false;
  dialogContent = "";
  dialogLoading = false;
  tableData = [];
  mobileSendStatus = -1;
  emailSendStatus = -1;
  noticeStatus = 0;

  sendStatusList = [
    { value: -1, label: "全部" },
    { value: 0, label: "等待结果" },
    { value: 1, label: "发送成功" },
    { value: 2, label: "发送失败" },
    { value: 255, label: "未发送" }
  ];
  emailStatusList = [
    { value: -1, label: "全部" },
    { value: 0, label: "等待结果" },
    { value: 1, label: "发送成功" },
    { value: 2, label: "发送失败" },
    { value: 255, label: "未发送" }
  ];
  noticeStatusList = [
    { value: 0, label: "全部" },
    { value: 1, label: "面试邀请" },
    { value: 20, label: "职位组邀请" },
    { value: 2, label: "面试通过通知" },
    { value: 3, label: "面试拒绝通知" },
    { value: 4, label: "面试待定通知" },
    { value: 5, label: "面试提醒通知" },
    { value: 6, label: "面试报告通知" }
  ];

  created() {
    this.searchForm.examId = Number(this.$route.query?.toExamId || 0);
    this.getAllExam();
  }

  mounted() {
    this.getTableData();
  }

  async getTableData(goFirst = true, clearSelected = true) {
    if (goFirst) {
      this.searchForm.page = 1;
    }
    if (clearSelected) {
      (this.$refs.multipleTable as any)?.clearSelection();
    }
    this.searchForm.companyId = parseInt(Auth.companyId);
    this.searchForm.emailSendStatusList =
      this.emailSendStatus === -1 ? [] : [this.emailSendStatus];
    this.searchForm.mobileSendStatusList =
      this.mobileSendStatus === -1 ? [] : [this.mobileSendStatus];
    this.searchForm.env = this.noticeStatus ? [this.noticeStatus] : [];
    try {
      this.tableLoading = true;
      const result = await LogNew.getList(this.searchForm);
      this.tableData = result.data.list;
      this.total = result.data.count;
    } finally {
      this.tableLoading = false;
    }
  }

  async refresh() {
    if (this.canRefresh) {
      this.canRefresh = false;
      await this.getTableData();
      this.$message.success("刷新成功");
      setTimeout(() => {
        this.canRefresh = true;
      }, 1000);
    }
  }
  async getAllExam() {
    const p = new ExamGetAllForm();
    p.companyId = parseInt(Auth.companyId);
    this.examAll = [{ id: 0, name: "全部面试" }];
    const result = await ExamList.examGetAll(p);
    this.examAll = [
      ...this.examAll,
      ...result.list.map((item: any) => ({ id: item.examId, name: item.name }))
    ];
  }

  gotoManage() {
    this.$router.push("/message-temp-comp/list");
  }

  handleSelectionChange(selections: any) {
    this.selectedRowList = selections;
  }

  getTagClass(mobileSendStatus: number) {
    return [
      mobileSendStatus === 1
        ? "success"
        : mobileSendStatus === 2
        ? "failed"
        : "other"
    ];
  }

  sendMessage(logId: number) {
    this.sendParam.logId = logId;
    this.sendParam.sendEmail = false;
    this.sendParam.sendMobile = true;
    this.dialogTitle = "发送短信通知";
    this.dialogContent = "向候选人发送短信通知";
    this.showSendConfirmDialog = true;
  }

  sendEmail(logId: number) {
    this.sendParam.logId = logId;
    this.sendParam.sendEmail = true;
    this.sendParam.sendMobile = false;
    this.dialogTitle = "发送邮件通知";
    this.dialogContent = "向候选人发送邮件通知";
    this.showSendConfirmDialog = true;
  }

  canSend(row: any) {
    const r2 = row.submitStatus !== 1;
    const r1 = [0, 3].includes(row.submitStatus) && row.env === 1;
    const r3 = [1, 3].includes(row.auditStatus) && [2, 3].includes(row.env);
    return r2 && (r1 || r3);
  }

  changeSelectAll(selected: boolean) {
    (this.$refs.multipleTable as any)?.clearSelection();
    if (selected) {
      (this.$refs.multipleTable as any)?.toggleAllSelection();
    }
  }

  async sendMulti() {
    if (this.selectAll) {
      if (this.total > 2000) {
        this.$message.warning("单次最多通知【前2000条】");
      }
      const result = await LogNew.getAllIds(this.searchForm);
      if (result.code === 0) {
        this.batchSendParam.logIdList = result.data.list;
      }
    } else {
      this.batchSendParam.logIdList = this.selectedRowList.map(
        item => item.logId
      );
    }
    try {
      this.batchLoading = true;
      const result = await LogNew.batchSend(this.batchSendParam);
      if (result.code === 0) {
        this.$message.success("提交成功");
      } else {
        this.$message.error(result.message);
      }
    } finally {
      setTimeout(() => {
        this.batchLoading = false;
      }, 20000);
    }
  }

  async sendAskSubmit() {
    this.dialogLoading = true;
    try {
      const result = await LogNew.sendAsk(this.sendParam);
      if (result.code === 0) {
        this.$message.success("提交成功");
      } else {
        this.$message.error(result.message);
      }
    } finally {
      this.dialogLoading = false;
    }
  }
}
